import React from 'react'
import { ToggleButton, toggleButtonClasses, ToggleButtonGroup, Typography } from '@mui/material'

export interface ToggleGroupItem<T extends string> {
  title: string
  value: T
  disabled?: boolean
}
export interface ToggleGroupProps<T extends string> {
  value?: T
  items: Array<ToggleGroupItem<T>>
  width?: 'fill' | 'hug'
  label?: string
  onChange(e: React.MouseEvent<HTMLElement>, item: T): void
}

export const ToggleGroup = <T extends string>({ onChange, items, value, label, width }: ToggleGroupProps<T>) => {
  return (
    <>
      {label && (
        <Typography variant="body2" mb={1} fontWeight="500">
          {label}
        </Typography>
      )}
      <ToggleButtonGroup
        onChange={onChange}
        exclusive
        value={value}
        sx={({ palette }) => ({
          width: width === 'fill' ? `100%` : 'auto',
          background: palette.background.paper,
          p: 0.5,
          borderRadius: 2,
        })}
      >
        {items.map((item) => (
          <ToggleButton
            key={item.value}
            disabled={item.disabled}
            value={item.value}
            sx={({ palette }) => ({
              flex: width === 'fill' ? 1 : 'none',
              border: 'none',
              background: 'transparent',
              borderRadius: 2,
              color: palette.text.primary,
              fontWeight: 500,
              textTransform: 'none',
              '&:not(:last-child)': {
                mr: 0.5,
              },
              [`&.${toggleButtonClasses.selected}`]: {
                borderRadius: 2,
                backgroundColor: palette.background.default,
              },
              '&:hover': {
                borderRadius: 2,
              },
              [`&.${toggleButtonClasses.disabled}`]: {
                border: 'none',
              },
            })}
          >
            {item.title}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </>
  )
}
